module.exports = __webpack_public_path__ + "img/success-mark.a0fed820.svg";